import flattenSchema from '@rwitl/reformed-util/lib/flattenSchema'
//import generateKey from '@rwitl/reformed-util/lib/generateKey'
import mergeScreenStates from '@rwitl/reformed-util/lib/mergeScreenStates'

/**
 * Adds a page to the screen state, takes into account nested layout in order
 * to add a child page.
 * @param {object} screenState
 * @param {Array} nestedLayout
 */
function addPageToScreenState(screenState, nestedLayout){
  var newPage = createNewPageSubset()
  // TODO Write support for this scenario
  if (nestedLayout.length > 0)
    throw new Error('Child screens not yet supported.')

  return mergeScreenStates(screenState, newPage)
}

export default addPageToScreenState

/**
 * Creates an empty flat schema for single page and nested form.
 * @returns {object}
 */
function createNewPageSubset(){
  return flattenSchema({
    layout: [
      {
        "type": "page",
        "layout": [
          {
            "type": "form",
            "layout": [
              {
                "type": "unstyled"
              }
            ]
          }
        ]
      }
    ]
  })
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/addPageToScreenState.js